import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import { ProfileCashierAddButtonWsopBox } from "./profile-cashier-add-button.wsop.box";
import { ProfileCashierAddButtonDefaultBox } from "./profile-cashier-add-button.default.box";
import {ProfileCashierAddButtonHarrahsBox} from "./profile-cashier-add-button.harrahs.box";
import {ProfileCashierAddButtonMrGreenBox} from "./profile-cashier-add-button.mrgreen.box";

export const ProfileCashierAddButtonBox = styledByTheme(ProfileCashierAddButtonDefaultBox)
    .forHarrahs(ProfileCashierAddButtonHarrahsBox)
    .forWsop(ProfileCashierAddButtonWsopBox)
    .forMrGreen(ProfileCashierAddButtonMrGreenBox)
    .apply();
